import { render } from "./SwitchingExceptions.vue?vue&type=template&id=547bf406&scoped=true&ts=true"
import script from "./SwitchingExceptions.vue?vue&type=script&lang=ts"
export * from "./SwitchingExceptions.vue?vue&type=script&lang=ts"

import "./SwitchingExceptions.vue?vue&type=style&index=0&id=547bf406&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547bf406"]])

export default __exports__